export default theme => ({
  root: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    '& .MuiTypography-h5': {
      lineHeight: '1.8',
    },
  },
});
